import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function BiografieSchreibenLassen() {
  return (
    <MarketingPage
      eyebrow="Service · Biografie"
      h1={
        <>
          Eine Biografie schreiben lassen — am Telefon, in{" "}
          <Swoosh>zwölf</Swoosh> Wochen
        </>
      }
      lead={
        <>
          Eine <strong>Biografie schreiben zu lassen</strong> war jahrzehntelang
          etwas für Menschen mit viel Zeit, viel Geduld und einem Ghostwriter
          im Wohnzimmer. Vitanara verändert das. Die erzählende Person ruft an,
          wann immer Lust dazu besteht. Konrad und Ida — unsere KI-Biografen —
          hören zu, fragen behutsam nach und verwandeln die Gespräche nach
          rund zwölf Wochen in ein in Leinen gebundenes Buch.
        </>
      }
      sections={[
        {
          h2: "Was bedeutet eigentlich „Biografie schreiben lassen“?",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Eine Biografie ist die schriftliche Lebensgeschichte eines
                Menschen — von der Kindheit bis heute, oder zu einem bestimmten
                Abschnitt. Klassisch werden solche Bücher von einem{" "}
                <strong>Ghostwriter</strong> verfasst, der über Monate hinweg
                Interviews führt, Tonbänder transkribiert, Manuskripte
                abstimmt und am Ende ein Buch druckt. Ein wertvoller Prozess —
                aber auch ein anstrengender, besonders für ältere Menschen.
              </p>
              <p style={{ margin: 0 }}>
                Vitanara verfolgt denselben Anspruch — ein würdiges, ehrliches,
                gut lesbares Buch — mit einem anderen Weg dorthin. Statt
                Interview-Terminen gibt es eine Telefonnummer, die Tag und
                Nacht erreichbar ist. Erzählt wird, wann es passt.
              </p>
            </>
          ),
        },
        {
          h2: "Wie unterscheidet sich Vitanara vom klassischen Ghostwriter?",
          body: (
            <>
              <p style={{ margin: "0 0 10px" }}>Drei Dinge sind anders:</p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Zugang.</strong> Kein vereinbarter Termin, keine Reise,
                kein fremder Mensch im Wohnzimmer. Ein Festnetzanschluss
                reicht.
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Tempo.</strong> Klassische Biografen brauchen oft sechs
                bis achtzehn Monate. Vitanara liefert in rund zwölf Wochen —
                weil sich die erzählende Person nicht nach Terminen richten
                muss, sondern erzählt, wenn ihr danach ist.
              </p>
              <p style={{ margin: 0 }}>
                <strong>Kosten.</strong> Ghostwriter-Biografien beginnen bei
                rund 5.000 Euro und reichen bei aufwendigen Projekten bis
                25.000 Euro. Vitanara ist in der laufenden Friends & Family
                Beta für eine begrenzte Zahl an Familien kostenlos.
              </p>
            </>
          ),
        },
        {
          h2: "Welche Lebensphasen werden behandelt?",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Das entscheidet die erzählende Person. Manche beginnen bei der
                Kindheit und arbeiten sich chronologisch vor. Andere springen
                — heute die Hochzeit, morgen ein Sommer in den Siebzigern,
                übermorgen der erste Tag im Beruf. Konrad und Ida sortieren
                später. Im fertigen Buch entsteht daraus eine Erzählung, die
                sich gut liest, ohne erfunden zu wirken.
              </p>
              <p style={{ margin: 0 }}>
                Themen, die oft auftauchen: Kindheit, Eltern und Geschwister,
                Schule, der erste Beruf, der Lebenspartner, Kinder, prägende
                Reisen, schwere Jahre, glückliche Jahre, was bleibt.
              </p>
            </>
          ),
        },
        {
          h2: "Wer kann eine Biografie schreiben lassen?",
          body: (
            <p style={{ margin: 0 }}>
              Jeder Mensch, der etwas zu erzählen hat. Die meisten
              Vitanara-Bücher entstehen für <strong>Großeltern</strong>, viele
              auch für <strong>Eltern</strong>, einige für{" "}
              <strong>Partner oder Geschwister</strong>. Vereinzelt schreiben
              Menschen ihre eigene Biografie für sich selbst — als
              Bestandsaufnahme vor einem runden Geburtstag oder einer
              Operation.
            </p>
          ),
        },
      ]}
      faqs={[
        {
          q: "Wie viele Anrufe sind nötig?",
          a: "Im Schnitt entstehen über zwölf Wochen zwischen fünfzehn und vierzig Gespräche. Manche kurz, manche lang.",
        },
        {
          q: "Muss ich vorher etwas vorbereiten?",
          a: "Nein. Konrad und Ida steigen mit offenen Fragen ein. Wer mag, legt Fotos oder Briefe griffbereit.",
        },
        {
          q: "Kann ich die Biografie nachträglich erweitern?",
          a: "Ja. Nach Erhalt des Buchs ist eine Erweiterung in einer zweiten Staffel möglich.",
        },
      ]}
      crossLinks={[
        {
          to: "/wie-funktioniert-vitanara",
          label: "Wie funktioniert Vitanara?",
          blurb:
            "Vom ersten Anruf bis zum leinengebundenen Buch — Schritt für Schritt.",
        },
        {
          to: "/preise",
          label: "Preise und Beta-Programm",
          blurb:
            "Während der Friends & Family Beta für ausgewählte Familien kostenlos.",
        },
        {
          to: "/lebensgeschichte-als-hoerbuch",
          label: "Auch als Hörbuch oder Podcast",
          blurb:
            "Ergänzend zum Buch: die Lebensgeschichte in der Originalstimme.",
        },
      ]}
    />
  );
}
